import React, { Component } from 'react';
import config from 'react-global-configuration';

import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class ContractRequisitionGroupComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      role_id: this.props.role_id,
      contract_requisition_group_id: this.props.contract_requisition_group_id,
      contract_requisition_group: this.props.contract_requisition_group,
      name_group_edit: this.props.contract_requisition_group.name,
      type_group_edit: this.props.contract_requisition_group.type,
      certifications_list: [],
      certification_id: '',
    };
    //bind específico
    this.editGroup = this.editGroup.bind(this);
    this.addCertification = this.addCertification.bind(this);
    this.deleteCertification = this.deleteCertification.bind(this);
    this.deleteRowCertification = this.deleteRowCertification.bind(this);

    // Handlers

    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    this.setState({role_id: newProps.role_id});
    this.setState({contract_requisition_group_id: newProps.contract_requisition_group_id});
    this.setState({contract_requisition_group: newProps.contract_requisition_group});
    this.setState({name_group_edit: newProps.contract_requisition_group.name});
    this.setState({type_group_edit: newProps.contract_requisition_group.type});
    this.setState({certifications_list: newProps.certifications_list});
  }

  editGroup(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name_group_edit,
      type: this.state.type_group_edit,
      id: this.state.contract_requisition_group_id,
    };
    var self = this;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cargo/requisicao/grupo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.props.refreshGroups(responseJson.data);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addCertification(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      certification_id: this.state.certification_id,
      contract_requisition_group_id: this.state.contract_requisition_group_id,
    };
    var self = this;
    var header = this.props.RequestApi.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/contrato/requisicao/grupo/treinamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.loadData(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteCertification (event) {
    var contract_requisition_group_certification_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Cargos.EditarCargo.tabCertificados.deletarCertificado);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/contrato/requisicao/grupo/treinamento/' + contract_requisition_group_certification_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRowCertification(contract_requisition_group_certification_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRowCertification(contract_requisition_group_certification_id) {
    var data = this.state.contract_requisition_group.contract_requisition_group_certifications;
    data.map(function(dado, index){
      if (dado.id == contract_requisition_group_certification_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }


  render() {
    var self = this;
    return (
<div>
  <hr/>
  <div>
    <h4 className="pull-left">{self.state.contract_requisition_group.name}</h4>
    <button className="btn btn-danger btn-sm pull-right" value={self.state.contract_requisition_group.id} onClick={this.props.deleteGroup}>
    <i className="fa fa-fw fa-trash"></i></button>
    <div className="clearfix"></div>
  </div>
  <hr/>
  <div className="row">
    <div className="col-md-6">
      <form onSubmit={self.editGroup}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabCertificados.formularioEditarGrupo.Nome}:</label>
              <input type="text" name='name_group_edit' className="form-control" placeholder="Nome do grupo" value={self.state.name_group_edit} onChange={self.handleChange.bind(self, 'name_group_edit')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabCertificados.formularioEditarGrupo.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type_group_edit"
                value={this.state.type_group_edit}
                searchable={true}
                placeholder={'Selecione o tipo'}
                onChange={this.handleSelectChange.bind(this, 'type_group_edit')}
                options={[
                  {value: "E", label: this.locale.Cargos.EditarCargo.tabCertificados.formularioEditarGrupo.opcoesTipo.E},
                  {value: "OU", label: this.locale.Cargos.EditarCargo.tabCertificados.formularioEditarGrupo.opcoesTipo.OU},
                ]}
              />    
            </div>
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Cargos.EditarCargo.tabCertificados.formularioEditarGrupo.botaoEditarGrupo}</button>
      </form>
    </div>
    <div className="col-md-6">
      <form onSubmit={self.addCertification}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabCertificados.formularioIncluirTreinamento.Treinamento}:</label>
              <Select
                className="form-field-name"
                name="certification_id"
                value={this.state.certification_id}
                searchable={true}
                placeholder={'Selecionar treinamento'}
                onChange={this.handleSelectChange.bind(this, 'certification_id')}
                options={this.state.certifications_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <br/>
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Cargos.EditarCargo.tabCertificados.formularioIncluirTreinamento.botaoIncluirTreinamento}</button>
          </div>
        </div>
      </form>
      <table className="table">
        <thead>
          <tr>
            <th>
              {this.locale.Cargos.EditarCargo.tabCertificados.tabelaGrupo.Treinamento}
            </th>
            <th>{this.locale.Cargos.EditarCargo.tabCertificados.tabelaGrupo.Acoes}</th>
          </tr>
        </thead>
        {Object.keys(self.state.contract_requisition_group.contract_requisition_group_certifications).map(function(k) {
          return (
            <tbody id="treinamentos">
              <tr>
                <td>
                  {self.state.contract_requisition_group.contract_requisition_group_certifications[k].certification.name}
                </td>
                <td>
                  <button className="btn btn-sm btn-danger" value={self.state.contract_requisition_group.contract_requisition_group_certifications[k].id} onClick={self.deleteCertification}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          );
        })}
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default ContractRequisitionGroupComponent;



// WEBPACK FOOTER //
// ./src/Components/Roles/Elements/ContractRequisitionGroupComponent.js